import PropTypes from "prop-types";
import React from "react";

import { StyleSheet, Text } from "react-native";
import { connect } from "react-redux";

import fonts from "../constants/fonts";

class DependencyDetailCustom extends React.Component {
  static propTypes = {
    fullName: PropTypes.string.isRequired
  };

  render() {
    const { fullName, themeColors } = this.props;

    return (
      <>
        <Text
          numberOfLines={1}
          style={[
            styles.fullName,
            {
              color: themeColors.darkerPrimary
            }
          ]}
        >
          {fullName}
        </Text>
      </>
    );
  }
}

const styles = StyleSheet.create({
  fullName: {
    fontSize: 20,

    ...fonts.bold
  }
});

export default connect(state => ({
  themeColors: state.themeColors
}))(DependencyDetailCustom);
